import { useCallback, useContext, useEffect } from "react";
import WebhookAction from "../components/WebhookAction";
import Request from "../components/Request";
import { Button, Card, Col, Row, Typography } from "antd";
import RequestHeader from "../components/RequestHeader";
import WebhookFields from "../components/WebhookFields";
import requests from "../lib/requests";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormField, { FormContext, FormProvider } from "./FormField";

function EditWebhook() {
  return (
    <FormProvider>
      <WebhookComponents />
    </FormProvider>
  );
}

export default EditWebhook;

/**
 * -------------------------------
 * Webhook component is set here to enable us use Form Proivder and context
 * -------------------------------
 */
function WebhookComponents() {
  const { fields, setValue } = useContext(FormContext);
  const params = useParams();
  const navigate = useNavigate();

  const fetchWebhookData = useCallback(async () => {
    try {
      const reqData = requests.get(`/webhooks/${params.webhookId}`);
      let data = { ...(await reqData).data.data };
      data.headers = initialHeaders(data.headers);
      data.schema = JSON.parse(data.schema);
      setValue(data);
    } catch (error) {
      setValue({});
      console.log("error fetching webhook details ");
    }
  }, []);

  const initialHeaders = (initialHeads: any) => {
    try {
      if (initialHeads) {
        if (typeof initialHeads === "string") {
          initialHeads = JSON.parse(initialHeads);
        }
      }
      return Object.keys(initialHeads).map((key, index) => [
        key,
        initialHeads[key],
      ]);
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    fetchWebhookData();
  }, []);

  const onSubmit = async (values: any) => {
    try {
      let formFields = fields;
      let headers = null;
      if (Array.isArray(formFields.headers)) {
        if (formFields.headers.length) {
          const fdata = formFields.headers.map((head: any[]) => ({
            [head[0]]: head[1],
          }));
          if (fdata.length) {
            headers = {};
            for (const h of fdata) {
              headers = { ...headers, ...h };
            }
          }
        }
      }

      formFields.headers = headers;

      console.log(headers, " the headers ");
      await requests.put(`/webhooks/${params.webhookId}`, {
        ...formFields,
      });

      console.log("webhook updated successfully");
      navigate("/");
    } catch (error) {
      console.log("updated error ");
    }
  };

  return (
    <Col style={{ padding: "20px" }}>
      <FormField onSubmit={onSubmit}>
        <Row style={{ flexDirection: "column", gap: "20px" }}>
          <WebhookAction type={"edit"} />
          <WebhookFields />
          <Request />
          <RequestHeader />
          <Card>
            <Row style={{ gap: "20px" }}>
              <Col>
                <Link to={"/"}>
                  <Button
                    htmlType="button"
                    style={{ backgroundColor: "#8B0000" }}
                  >
                    <Typography.Text
                      style={{
                        color: "#fff",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                    >
                      Cancel
                    </Typography.Text>
                  </Button>
                </Link>
              </Col>
              <Col>
                {" "}
                <Button htmlType="submit" type="primary">
                  <Typography.Text
                    style={{
                      color: "#fff",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                    }}
                  >
                    Update
                  </Typography.Text>
                </Button>
              </Col>
            </Row>
          </Card>
        </Row>
      </FormField>
    </Col>
  );
}
